// src/services/axios.js
import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Accept'] = 'application/json'

// Get CSRF token from meta tag and set it in axios
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken
}

// Track last 401 redirect to prevent loops
let last401Redirect = 0
const REDIRECT_COOLDOWN = 5000 // 5 seconds between redirects

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname
      const now = Date.now()

      // Prevent redirect loops - only redirect if we haven't redirected in the last 5 seconds
      if (!currentPath.includes('/login') && (now - last401Redirect) > REDIRECT_COOLDOWN) {
        console.warn('[401 Interceptor] Clearing auth data due to 401 response')
        localStorage.removeItem('userData')
        localStorage.removeItem('accessToken')
        localStorage.removeItem('userRole')
        localStorage.removeItem('userAbilities')

        console.warn('[401 Interceptor] Session expired, redirecting to login')
        last401Redirect = now
        window.location.href = '/login'
      } else if ((now - last401Redirect) <= REDIRECT_COOLDOWN) {
        console.warn('[401 Interceptor] Suppressing redirect to prevent loop')
      }
    }
    
    return Promise.reject(error)
  },
)

export default axios
